import { render } from "./MainAccess.vue?vue&type=template&id=a254c4ac&scoped=true"
import script from "./MainAccess.vue?vue&type=script&lang=js"
export * from "./MainAccess.vue?vue&type=script&lang=js"

import "./MainAccess.vue?vue&type=style&index=0&id=a254c4ac&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a254c4ac"]])

export default __exports__